import axios from "axios";
import {useAuthStore} from "@src/stores/auth";
// @ts-ignore
import notification1 from "@src/assets/sounds/notification1.mp3";
// @ts-ignore
import notification2 from "@src/assets/sounds/notification2.mp3";
// @ts-ignore
import notification3 from "@src/assets/sounds/notification3.mp3";
// @ts-ignore
import notification4 from "@src/assets/sounds/notification4.mp3";
// @ts-ignore
import notification5 from "@src/assets/sounds/notification5.mp3";
// @ts-ignore
import notification6 from "@src/assets/sounds/notification6.mp3";
import {useWebNotification} from "@vueuse/core";
import {Capacitor} from '@capacitor/core';
import {LocalNotifications} from '@capacitor/local-notifications';


class NotificationsService {

    public soundMap: Record<string, string> = {
        "notification1.mp3": notification1,
        "notification2.mp3": notification2,
        "notification3.mp3": notification3,
        "notification4.mp3": notification4,
        "notification5.mp3": notification5,
        "notification6.mp3": notification6,
    };
    private key = 'operatorv4:permissions';
    // lazy getter — só acessa o Pinia quando chamado
    private get authStore() {
        return useAuthStore();
    }

    async setNotifyGroups(value: boolean) {
        const stored = localStorage.getItem(this.key);
        if (!stored) return;

        const permissions = JSON.parse(stored);

        permissions.notify_groups = value;

        localStorage.setItem(this.key, JSON.stringify(permissions));

        await axios.post(
            `/operator/v4/change-notifications`,
            {
                notify: "groups",
                value: value
            }
        );
    }

    getNotifyGroups(): boolean | null {
        const stored = localStorage.getItem(this.key);
        if (!stored) return null;

        const permissions = JSON.parse(stored);

        return permissions.notify_groups ?? null;
    }

    async setNotifyBots(value: boolean) {
        const stored = localStorage.getItem(this.key);
        if (!stored) return;

        const permissions = JSON.parse(stored);

        permissions.notify_bots = value;

        localStorage.setItem(this.key, JSON.stringify(permissions));

        await axios.post(
            `/operator/v4/change-notifications`,
            {
                notify: "bot",
                value: value
            }
        );
    }

    getNotifyBots(): boolean | null {
        const stored = localStorage.getItem(this.key);
        if (!stored) return null;

        const permissions = JSON.parse(stored);

        return permissions.notify_bots ?? null;
    }

    setNotification(notification: string) {
        axios.post(
            `/operator/v4/user/settings`,
            {
                key: "notification",
                value: notification
            }
        );
    }

    notify(message = '', isGroup = false, isBot = false) {
        if(isGroup && !this.getNotifyGroups()) return;
        if(isBot && !this.getNotifyBots()) return;

        if(message !== '') {
            if (Capacitor.isNativePlatform()) {
                // No nativo, a notificação do sistema já tem seu próprio som/canal —
                // não tocar áudio do WebView aqui, senão soa como um som de app/jogo
                // preso ao volume de mídia, além de não funcionar em background.
                LocalNotifications.schedule({
                    notifications: [{
                        title: 'dChat',
                        body: message,
                        id: Date.now() % 2147483647,
                        // Sem isso, o iOS não toca som algum (o campo é opcional
                        // e o plugin só seta content.sound se ele vier preenchido).
                        // "default" não é o nome de um arquivo real — o plugin
                        // cai no som padrão do sistema quando o arquivo não é encontrado.
                        sound: 'default',
                    }]
                }).catch(() => {});
                return;
            } else {
                const { show, isSupported } = useWebNotification({
                    title: 'dChat',
                    body: message,
                    dir: 'auto',
                    lang: 'pt_BR',
                    renotify: true,
                    tag: 'dChat',
                    icon: '/images/favicon/favicon-96x96.png',
                });

                if(isSupported.value) {
                    show();
                }
            }
        }

        // @ts-ignore
        const selectedNotification = this.authStore.user?.settings.notification ?? "notification1.mp3";
        const audio = new Audio(this.soundMap[selectedNotification]);
        audio.play();
    }

}

export default new NotificationsService();